import { render, staticRenderFns } from "./jiancha.vue?vue&type=template&id=6096aff0"
import script from "./jiancha.vue?vue&type=script&lang=js"
export * from "./jiancha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports